export default __webpack_public_path__ + "static/media/qg1.8dc5525d.jpeg";